import { createTheme } from '@mui/material/styles';
import { BODY, DISPLAY, M } from './ui';

/** Skin applied to pages that have not been rebuilt by hand yet, so their buttons, fields and headings match the marketplace. */
const marketplaceTheme = (outer: any) => createTheme(outer, {
  palette: {
    primary: { main: M.navy, dark: M.navyDark, contrastText: '#fff' },
    secondary: { main: M.gold, contrastText: M.navy },
    background: { default: M.bg, paper: '#fff' },
    text: { primary: M.text, secondary: M.text2 },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: BODY,
    h1: { fontFamily: DISPLAY, fontWeight: 800, color: M.navy },
    h2: { fontFamily: DISPLAY, fontWeight: 800, color: M.navy },
    h3: { fontFamily: DISPLAY, fontWeight: 800, color: M.navy },
    h4: { fontFamily: DISPLAY, fontWeight: 800, color: M.navy },
    h5: { fontFamily: DISPLAY, fontWeight: 700, color: M.navy },
    h6: { fontFamily: DISPLAY, fontWeight: 700, color: M.navy },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 700, borderRadius: 12, minHeight: 40 }, containedPrimary: { backgroundColor: M.navy, '&:hover': { backgroundColor: M.navyDark } }, outlinedPrimary: { borderWidth: 1.5, '&:hover': { borderWidth: 1.5 } } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 16, border: `1px solid ${M.border}`, boxShadow: 'none' } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 16 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 12, backgroundColor: '#fff' } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 700 } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 700 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 20 } } },
  },
});

export default marketplaceTheme;
